export default "__VITE_ASSET__C2TLST3c__"